export const CONVERSATION_CLIENT_READY = 'CONVERSATION_CLIENT_READY';
export const CONVERSATION_CREATE = 'CONVERSATION_CREATE';
export const CONVERSATION_MESSAGE_MARK_AS_READ = 'CONVERSATION_MESSAGE_MARK_AS_READ';
export const CONVERSATION_SEND_MESSAGE = 'CONVERSATION_SEND_MESSAGE';
export const CONVERSATION_SET_STATUS = 'CONVERSATION_SET_STATUS';
export const CONVERSATION_LOAD_MORE = 'CONVERSATION_LOAD_MORE';

export const EXERCISE_EDIT_SELECT_EXERCISE = 'EXERCISE_EDIT_SELECT_EXERCISE';
export const EXERCISE_EXERCISE_SKILL_CHANGE_EVALUATION_CRITERIA =
  'EXERCISE_EXERCISE_SKILL_CHANGE_EVALUATION_CRITERIA';
export const EXERCISE_EXERCISE_SKILL_ADD = 'EXERCISE_EXERCISE_SKILL_ADD';
export const EXERCISE_EXERCISE_SKILL_REMOVE = 'EXERCISE_EXERCISE_SKILL_REMOVE';
export const EXERCISE_CHANGE = 'EXERCISE_EDIT_CHANGE';
export const EXERCISE_TOGGLE_ACTIVE = 'EXERCISE_TOGGLE_ACTIVE';

export const PRIVATE_CONVERSATION_SELECT = 'PRIVATE_CONVERSATION_SELECT';
export const PRIVATE_CONVERSATION_SHOW_CREATE_NEW = 'PRIVATE_CONVERSATION_SHOW_CREATE_NEW';

export const UI_CONVERSATIONBOX_END_INITIAL_LOADING = 'UI_CONVERSATIONBOX_END_INITIAL_LOADING';
export const UI_CONVERSATIONBOX_PAGINATION_INCREASE = 'UI_CONVERSATIONBOX_PAGINATION_INCREASE';
export const UI_CONVERSATIONBOX_SET_LOADING = 'UI_CONVERSATIONBOX_SET_LOADING';
export const UI_CONVERSATIONBOX_SET_FULLY_LOADED = 'UI_CONVERSATIONBOX_SET_FULLY_LOADED';

export const USERS_REQUEST = 'USERS_REQUEST';
export const USERS_RECEIVE = 'USERS_RECEIVE';
export const USERS_REQUEST_FAILURE = 'USERS_REQUEST_FAILURE';
export const USERS_REQUEST_SUCCESS = 'USERS_REQUEST_SUCCESS';
